<style lang="scss">
.calls {}
</style>

<!-- eslint-disable -->
<template>
  <div class="theme-color-wrapper p-2 visitor-search-page">
    <div class="calls row">
      <div class="col-12">
        <h2 cy="page-title" class="font-weight-bolder mb-3">Visitor Management</h2>

        <section class="my-2 mb-3 d-flex flex-row">
          <b-form-input
            @input="filterResults()"
            placeholder="Search..."
            cy="visitor-search"
            v-model="search"
            class="col-6"
          />
          <div class="ui-spacer" />
          <b-btn variant="primary" @click="showDuplicates = !showDuplicates">
            {{ showDuplicates ? 'Show all' : 'Show duplicates' }}
          </b-btn>
        </section>

        <b-card no-body class="mb-0">
          <section>
            <b-table
              class="data-table" cy="visitor-table"
              hover
              :items="displayedVisitors"
              :fields="headers"
              :current-page="currentPage"
              :per-page="perPage"
              :busy="loading"
              :responsive="true"
            >
              <template #cell(name)="data">
                {{data.item.firstname}} {{data.item.lastname}}
              </template>

              <template #cell(actions)="data">
                <b-button variant="link" @click="$router.push({ name: 'visitor-profile', params: { id: data.item.user_id } })">
                  View
                </b-button>
              </template>

            </b-table>
            <b-row>
              <b-col md="6" class="my-1" v-if="displayedVisitors.length > 0">
                <b-pagination :total-rows="displayedVisitors.length" :per-page="perPage" v-model="currentPage" class="my-0"/>
              </b-col>
              <p v-if="displayedVisitors.length === 0" class="col-6 ml-2 my-1">{{loading ? "Loading...." : "No visitors to show"}}</p>
            </b-row>
          </section>
        </b-card>
      </div>
    </div>
  </div>
</template>
<!-- eslint-enable -->

<script>
import { mapState } from 'vuex';
import VisitorService from '@/services/VisitorService';

export default {
  name: 'VisitorSearch',
  components: {},
  props: {},
  data() {
    const headers = [
      { label: 'Name', key: 'name' },
    ];
    // Hide email from HMPPS prisons
    if (this.$store.state.prison.prison && this.$store.state.prison.prison.group_id !== '21a4a4957bfd41c1836ac1d127581975') {
      headers.push({ label: 'Email', key: 'email' });
    }
    headers.push({ label: 'Actions', key: 'actions' });
    return {
      search: '',
      loading: false,
      visitors: [],
      visitorsFiltered: [],
      currentPage: 1,
      perPage: 10,
      headers,
      showDuplicates: false,
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
    }),
    duplicates() {
      const visitorMap = new Map();
      this.visitors.forEach(visitor => {
        const key = `${visitor.lastname}-${visitor.dob}`;
        if (!visitorMap.has(key)) {
          visitorMap.set(key, []);
        }
        visitorMap.get(key).push(visitor);
      });
      return this.visitors.filter(visitor => {
        const key = `${visitor.lastname}-${visitor.dob}`;
        return visitorMap.get(key).length > 1;
      });
    },
    displayedVisitors() {
      return this.showDuplicates ? this.duplicates : this.visitorsFiltered;
    },
  },
  mounted() {
    this.getVisitors();
  },
  methods: {
    getVisitors() {
      this.loading = true;
      VisitorService.getVisitorsWithContactInPrison().then(res => {
        this.visitors = res.data.filter(visitor => visitor.verification_status === 'Verified');
        this.filterResults();
      }).catch(err => {
        console.log('Error getting visitors', err);
        this.$toast.error('Could not get visitors, please refresh and try again', {
          toastClassName: ['toast-std', 'warning-toast'],
        });
      }).finally(() => {
        this.loading = false;
      });
    },
    filterResults() {
      if (!this.search) {
        this.visitorsFiltered = [...this.visitors];
      } else {
        this.visitorsFiltered = this.visitors.filter(person => {
          const fullName = `${person.firstname} ${person.lastname}`;
          const name = fullName.toLowerCase().includes(this.search.toLowerCase());
          const email = person.email.toLowerCase().includes(this.search.toLowerCase());

          return name || email;
        });
      }
    },
  },
}
</script>
